
import MdContent from 'components/md-content'
import ArticleCard from './article-card.vue'

export default {
  components: {
    MdContent,
    ArticleCard
  },
  props: {
    links: {type: Object, required: true}
  },
  computed:{
    content(){
      return this.links.content
    },
    show_navs(){
      return this.content.length > 2
    },
    v_heihgt(){
      return this.content.length >= 2 ? '19.8rem' : '9.9rem'
    },
    summary(){
      return this.links.summary
    },
    title(){
      return this.links.title
    },
    loading(){
      return !this.content
    }
  },
}
